module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAA90lEQVQ4T53SyypGURgG4OebOhRR7sDETBkxkUzNKcXcHbgbDBzKdZiJgWQklIFkRCn6tLT23/4PfrJmu72e3rXe9YV/rviLy8xRrOMFpxGRv8LMHMEClmvINY6Gwswcxxbu8Iqlii9/hJk5hm1M1c3neMMibgbCVlKDmiou8IyzPjggqd1fOfJeRHx0wSFJBd/ioKDy0YG/JBW0HxGfTfw3zMwJbLaKaB+vK6kXztV3mu4ZiL6kDszMSezgGKto8MCkNpzHGsr5T7BS36u017lT72hGZm5gtv4ojR3iPiLeh81xgbu13cdaecFPEXGVmTMo9+9dD1+cmF3aDIrspwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/editHover.png
// module id = hrS/
// module chunks = 2